import bootstrapper from '../../bootstrapper';
import ghostInspector from './ghostInspector';
import initGhostInspector from './ghostInspector/initializer';
import logger from './logger';
import { emeritusPixelMiddleware, initEmeritusPixel } from './emeritusPixel';

let middlewares;

switch (bootstrapper.appEnv) {
  case 'test': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'development': middlewares = [logger, emeritusPixelMiddleware]; break;
  case 'review_app': middlewares = [logger, ghostInspector, emeritusPixelMiddleware]; break;
  case 'staging': middlewares = [logger, ghostInspector, emeritusPixelMiddleware]; break;
  case 'production': middlewares = [emeritusPixelMiddleware]; break;
  default: middlewares = []; break;
}

export default {
  list: middlewares,
  initialize: () => {
    initGhostInspector();
    initEmeritusPixel(true);
  },
};
